import React from 'react'

const terms = () => {
  return (
    <div className='bg-slate-900'>
      <div className="min-h-screen bg-slate-950 text-white p-8 animate-pop">
      <h1 className="text-3xl font-bold mb-6">Terms and Conditions</h1>
      <p className="mb-4">
        Welcome to Tech Studios! By accessing and using our website <a href="https://www.techstudios.co.in/" className="text-blue-400 hover:underline">https://www.techstudios.co.in/</a>, you agree to comply with the following terms and conditions.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">1. Acceptance of Terms</h2>
      <p className="mb-2">
        By using our website, you acknowledge that you have read, understood, and agreed to these Terms and Conditions. If you do not agree, please refrain from using our website.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">2. Use of Website</h2>
      <p className="mb-2">
        You must be at least 18 years old or have parental consent to use this website.
      </p>
      <p className="mb-2">
        You agree to use this website for lawful purposes only and in compliance with all applicable laws and regulations.
      </p>
      <p className="mb-2">
        Unauthorized use of our website, including hacking, data scraping, or distributing harmful content, is strictly prohibited.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">3. Intellectual Property Rights</h2>
      <p className="mb-2">
        All content on this website, including text, images, logos, designs, and software, is the property of Tech Studios and is protected by copyright and intellectual property laws.
      </p>
      <p className="mb-2">
        You may not copy, reproduce, modify, distribute, or use any content without our express written permission.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">4. User-Generated Content</h2>
      <p className="mb-2">
        If you submit any content (e.g., reviews, comments, testimonials), you grant us a non-exclusive, royalty-free, worldwide license to use, modify, and publish it.
      </p>
      <p className="mb-2">
        You agree that your submissions will not contain unlawful, defamatory, or offensive material.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">5. Limitation of Liability</h2>
      <p className="mb-4">
        Tech Studios shall not be liable for any direct, indirect, incidental, consequential, or special damages arising from your use of the website.
      </p>
      <p className="mb-4">
        We do not guarantee uninterrupted or error-free operation of the website.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">6. Third-Party Links</h2>
      <p className="mb-2">
        Our website may contain links to third-party websites for informational purposes.
      </p>
      <p className="mb-2">
        We do not endorse, control, or take responsibility for the content or privacy policies of external sites.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">7. Termination of Use</h2>
      <p className="mb-4">
        We reserve the right to terminate or restrict access to our website at our discretion, without prior notice, if we believe you have violated these terms.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">8. Changes to Terms and Conditions</h2>
      <p className="mb-4">
        We may update these Terms and Conditions at any time. Continued use of the website after changes signifies your acceptance of the updated terms.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">9. Governing Law</h2>
      <p className ="mb-4">
        These Terms and Conditions are governed by the laws of [Insert Jurisdiction]. Any disputes shall be resolved in the courts of [Insert Jurisdiction].
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">10. Refund Policy</h2>
      <p className="mb-4">
        Any advance payment made for services or products is non-refundable. Once payment is received, it cannot be refunded under any circumstances.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">11. Contact Us</h2>
      <p className="mb-4">
        For any questions regarding these Terms and Conditions, please contact us at support@techstudios.co.in.
      </p>
    </div>
    </div>
  )
}

export default terms
